import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        <p>
          © 2026 Elevate Space. All rights reserved.
        </p>

        <div className="footer-links">
          <span>Privacy Policy</span>
          <span>Terms</span>
          <span>Contact</span>
        </div>

      </div>
    </footer>
  );
}

export { Footer };